"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dangerousUncheckedTypeCast = exports.exhaustiveTypeException = exports.exhaustiveTypeCheck = exports.isInArray = void 0;
const isInArray = (value, array) => array.includes(value);
exports.isInArray = isInArray;
const exhaustiveTypeCheck = (_) => void _;
exports.exhaustiveTypeCheck = exhaustiveTypeCheck;
const exhaustiveTypeException = (type) => new Error(`Assertion failed: "unreachable" code reached with unknown type: ${typeof type === 'object' ? JSON.stringify(type) : String(type)}`);
exports.exhaustiveTypeException = exhaustiveTypeException;
/**
 * Please use this instead of using the 'as' keyword directly, so it's easier
 * to screen for these ticking time bombs in the code from time to time. Or
 * better yet, just implement validation for your types straight away.
 *
 * If you would think twice before using this, then by pure logic you should
 * likewise also think twice - no, make it at least thrice - before making the
 * decision to opt into undefined behaviour by letting the compile-time TS type
 * diverge from the runtime JS value.
 *
 * This is your last chance to turn back.
 *
 * You have been warned.
 *
 * @example
 * ```ts
 * const someData = await AsyncStorage.getItem(SOME_KEY);
 * const parsedData = JSON.parse(someData);
 * const data = dangerousUncheckedTypeCast<SomeDataType>(parsedData);
 * ```
 */
const dangerousUncheckedTypeCast = (value) => value;
exports.dangerousUncheckedTypeCast = dangerousUncheckedTypeCast;
